// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export const projectIdMap = new Map([['kubernetes', 'a092M00001IV42DQAT']]);
